import { notification } from 'antd'

const showErrorNotification = ({ title, description, duration }) =>
  notification.error({
    message: title,
    description,
    type: 'error',
    duration,
  })

export default showErrorNotification
